export default __webpack_public_path__ + "static/media/Untitled-2.24055a9c.jpg";